import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { tableStore } from "../store/table";
import AlternateTimes from "./AlternateTimes";
import Details from "./Details";
import Packages from "./Packages";
import Start from "./Start";
import Summary from "./Summary";
import Confirmed from "./Confirmed";

const Wrapper = styled.div`
  padding: 40px;
`;

const BookTable = () => {
  const {
    isActive,
    table,
    actions: { sendAnalyticsData },
  } = useContext(tableStore);

  const steps = {
    start: Start,
    alternate: AlternateTimes,
    details: Details,
    packages: Packages,
    confirmed: Confirmed,
  };

  const CurrentStep = steps[table.step];

  useEffect(() => {
    if (!isActive || !table.bookingTypeTitle) return;
    sendAnalyticsData({
      hitType: "event",
      eventAction: "Selection",
      eventLabel: `Type - ${table.bookingTypeTitle}`,
    });
  }, [isActive, table.bookingTypeTitle]);

  return (
    <>
      {table.step !== "start" ? <Summary /> : null}
      <Wrapper>
        <CurrentStep />
      </Wrapper>
    </>
  );
};

export default BookTable;
